import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=2829a430&scoped=true"
import script from "./empty.vue?vue&type=script&lang=js"
export * from "./empty.vue?vue&type=script&lang=js"
import style0 from "./empty.vue?vue&type=style&index=0&id=2829a430&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2829a430",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2829a430')) {
      api.createRecord('2829a430', component.options)
    } else {
      api.reload('2829a430', component.options)
    }
    module.hot.accept("./empty.vue?vue&type=template&id=2829a430&scoped=true", function () {
      api.rerender('2829a430', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/empty.vue"
export default component.exports